import { Link } from 'react-router-dom';

import styles from '../../../../styles/Admin.module.scss';

function Item({ _id, active, name, amount, interval_count, interval, tokensPerCycle, openGymTokensPerCycle, classTokensPerCycle, tokenExpiryDays }) {
	const expiryText = tokenExpiryDays ? `, expires after ${tokenExpiryDays} day${tokenExpiryDays === 1 ? '' : 's'}` : '';

	return (
		<Link to={_id} className={`${styles.product} ${active ? "" : styles.disabled}`}>
			<p>{name} <strong>£{(amount / 100).toFixed(2)}</strong> every {interval_count} {interval}{interval_count > 1 ? 's' : ''}</p>
			{tokensPerCycle > 0 && <p>{tokensPerCycle} token{tokensPerCycle === 1 ? '' : 's'} per payment{expiryText}</p>}
			{openGymTokensPerCycle > 0 && <p>{openGymTokensPerCycle} open gym token{openGymTokensPerCycle === 1 ? '' : 's'} per payment{expiryText}</p>}
			{classTokensPerCycle > 0 && <p>{classTokensPerCycle} class token{classTokensPerCycle === 1 ? '' : 's'} per payment{expiryText}</p>}
		</Link>
	)
}

export default Item;
